module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"NotNot","short_name":"Landing","start_url":"/","background_color":"#A0008C","theme_color":"#A0008C","display":"standalone","icon":"src/assets/images/notnot.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"74fcf8bd13bffd57a19a48d280d2029e"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
